/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contact details of a service team member
 * @export
 * @interface ServiceTeamMemberProfile
 */
export interface ServiceTeamMemberProfile {
    /**
     * 
     * @type {string}
     * @memberof ServiceTeamMemberProfile
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceTeamMemberProfile
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceTeamMemberProfile
     */
    lastName: string;
}

/**
 * Check if a given object implements the ServiceTeamMemberProfile interface.
 */
export function instanceOfServiceTeamMemberProfile(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;

    return isInstance;
}

export function ServiceTeamMemberProfileFromJSON(json: any): ServiceTeamMemberProfile {
    return ServiceTeamMemberProfileFromJSONTyped(json, false);
}

export function ServiceTeamMemberProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTeamMemberProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function ServiceTeamMemberProfileToJSON(value?: ServiceTeamMemberProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
    };
}

